// extracted by mini-css-extract-plugin
export default {"cartItemUnitPrice":"cartItemUnitPrice__Y2I3O","cartItemOriginalPrice":"cartItemOriginalPrice__MDgxZ","smaller":"smaller__ZDNhM"};